const semanticClassNames = {
  root: 'fast-gallery',
  container: 'fast-gallery__container',
  item: 'fast-gallery__item',
  image: 'fast-gallery__image',
  info: 'fast-gallery__info',
} as const;

export default semanticClassNames;
